import { REPORT_OPTIONS } from '../PRFilters';

export const getPRReportTypeName = (id: string) => {
  const report = REPORT_OPTIONS.find((report) => report.value === id);

  return report?.label;
};
